module.exports = __webpack_public_path__ + "img/16-min.a9982324.jpg";